///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2026, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2026 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { IComponent } from "@inweb/viewer-core";
import type { Viewer } from "../Viewer";

export class CanvasRemoveComponent implements IComponent {
  protected viewer: Viewer;
  protected mutationObserver: MutationObserver;

  constructor(viewer: Viewer) {
    this.viewer = viewer;
    this.mutationObserver = new MutationObserver(this.cleanupViewer);
    this.mutationObserver.observe(document, { childList: true, subtree: true });
  }

  dispose() {
    this.mutationObserver.disconnect();
  }

  cleanupViewer = (mutations: MutationRecord[]) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
        for (const node of mutation.removedNodes) {
          if (node === this.viewer.canvas || node.contains(this.viewer.canvas)) {
            this.viewer.emitEvent({ type: "canvasremoved" });
            this.viewer.dispose();
            return;
          }
        }
      }
    }
  };
}
